'use client'

import { useEffect } from 'react'
import { logger } from "@/lib/logger"

const log = logger.scope("AppwritePing")

export function AppwritePing() {
  useEffect(() => {
    // Ping server API route which will use the server SDK with API key
    fetch('/api/ping')
      .then(res => res.json())
      .then(data => {
        if (!data.success) {
          log.error("Server connection failed", { error: String(data.error) })
        }
      })
      .catch(err => log.error("Ping failed", { error: String(err) }))
  }, [])

  return null
}
